import config from '../config';
import { ADPVersions, DiagnosticDataTransferReq } from "../Types";
import {post, put } from "./NetworkService";
const DeviceDiagnosticService = {
    initListeners:()=>{
      window.onbeforeunload = function() {
        //shows native warning message on refresh and navigation
        console.log(`[DeviceDiagnosticService] page is about to unload`)
        //return "page is about to unload";
      } 
      window.addEventListener('error', (event) => {
        console.error(`[DeviceDiagnosticService] Error`,event)
    });
    //@ts-ignore
if (console.everything === undefined) {
  //@ts-ignore
  console.everything = [];
  //@ts-ignore
  function TS(){
    return (new Date()).toLocaleString("sv", { timeZone: 'UTC' }) + "Z"
  }
  window.onerror = function (error, url, line) {
    //@ts-ignore
    console.everything.push({
      type: "exception",
      timeStamp: TS(),
      value: { error, url, line }
    });
   return false;
  }
  window.onunhandledrejection = function (e) {
    //@ts-ignore
    console.everything.push({
      type: "promiseRejection",
      timeStamp: TS(),
      value: e.reason
    })
  } 
//@ts-ignore
  function hookLogType(logType) {
    //@ts-ignore
    const original= console[logType].bind(console)
    return function(){
      //@ts-ignore
      console.everything.push({ 
        type: logType, 
        timeStamp: TS(), 
        value: Array.from(arguments) 
      })
      try {
        original.apply(console, arguments)
      }
      catch (e){
        console.log(`[hookLogType][Error][${e}]`)
      }
    }
  }

  ['log', 'error', 'warn', 'debug'].forEach(logType=>{
    //@ts-ignore
    console[logType] = hookLogType(logType)
  })
}  
   setInterval(()=>{
     //@ts-ignore
     if(window.console?.everything.length > 25){
      const fileName = `${Date.now()}.${config.getLaunchID()}-debug-log.json`;
        //@ts-ignore
      DeviceDiagnosticService.transfer.postLogs(fileName,window.console?.everything);
     }
  },60000);
    },
    transfer:{
      getSignedUrl:(url:string, payload:DiagnosticDataTransferReq,cb: any)=>{
        const response = post(url,payload);
        console.log(`[NetworkService][get server status][getSignedUrl][launch mode: ${config.getDeliveryMode()}]`);
        response.then((response: any) => {
          console.log(`[NetworkService][get server status][getSignedUrl: ${JSON.stringify(response)}]`);
          if(response.status === 200) cb(response.data.dataUri)
        }).catch((e) => {
          console.error(`[NetworkService][get server status][getSignedUrl not available: ${JSON.stringify(e)}`);
          cb(false)
        })
      },
      postLogs: (fileName:string,data?: any, loginId?:string)=> {
      // if(!config.getDeliveryMode()) return; //TODO - change it once BE will start accepting "notselected"
        const payload:DiagnosticDataTransferReq = {
          deliveryType: config.getDeliveryMode() || "notselected" ,
          dataType:"DIAGNOSTIC",
          dataSubCategory:"debug-logs",
          taskType: "UPLOAD",
          taskMessage: "Diagnostic Data Transfer from CB",
          data: {
            fileName: fileName,
            loginId: "N/A"
          },
          clientDetails: {
            ip: config.getLocalIPAddress(),
            appName: "ng-enaep-chrome-app",
            deviceDetails: {
              deviceName: config.getDeviceID(),
              deviceType:"NPE"
            }
          }
        };
        const onSignedUrl = async (response:any)=>{
          console.log('onSignedUrl',response);
          if(response){
            //@ts-ignore
            await put(response,console.everything);
            //@ts-ignore
            console.everything = [];
          }
         
        };
        const url = config.getDeliveryMode() === "ncs" ? config.getNCSAPI().getSignedUrl : config.getOnlineAPI().getSignedUrl
        DeviceDiagnosticService.transfer.getSignedUrl(url,payload,onSignedUrl)
      },
      postADPVersions: ()=> {
        //if(!config.getDeliveryMode()) return; //TODO - change it once BE will start accepting "notselected"
        const fileName = `${config.getLaunchID()}.adp-versions.json`;
        const data:ADPVersions = {
          "schemaVersion": "1.0.1",
          "deviceName": config.getDeviceID(),
          "userName": 'Student',
          "adpLaunchId":config.getLaunchID(),
          "appLaunchDateTime": config.getAppLaunchDateTime(),
          "releaseVersion": config.getContent().version,
          "buildNumber": config.getContent().version,
          "assessmentDeliveryMode": config.getDeliveryMode(),
          "appVersion":"adp-chrome-app",
          participantId: "N/A",
          setupCode:config.getSetupCode(),
           Versions: [{
            ChromeExtension:{
               Version: config.getChromeExtensionVersion()
            },
            Chrome:{
              Version: navigator.userAgent
            }
           }
           ]        
          }
         const payload:DiagnosticDataTransferReq = {
           deliveryType: config.getDeliveryMode() || "notselected" ,
           dataType:"DIAGNOSTIC",
           dataSubCategory:"adp-launch-state",
           taskType: "UPLOAD",
           taskMessage: "Diagnostic Data Transfer from CB",
           data: {
             fileName: fileName,
             loginId: "N/A"
           },
           clientDetails: {
             ip: config.getLocalIPAddress(),
             appName: "ng-enaep-chrome-app",
             deviceDetails: {
               deviceName: config.getDeviceID(),
               deviceType:"NPE"
             }
           }
         };
         const onSignedUrl = (response:any)=>{
           console.log('onSignedUrl',response);
           if(response){
             put(response,data);
           }
          
         };
         const url = config.getDeliveryMode() === "ncs" ? config.getNCSAPI().getSignedUrl : 
         config.getOnlineAPI().getSignedUrl
         DeviceDiagnosticService.transfer.getSignedUrl(url,payload,onSignedUrl)
       },
      
    }
}

export default DeviceDiagnosticService;
